import { BlockNoteDocument } from '../schema';
import isEmptyParagraph from './is-empty-paragraph';
import isImageOrTableBlock from './is-image-or-table-block';

export default function stripTrailingEmptyParagraphs(
  blocks: BlockNoteDocument,
) {
  let end = blocks.length;
  while (end > 0 && isEmptyParagraph(blocks[end - 1])) {
    const blockBefore = blocks[end - 2];
    if (blockBefore && isImageOrTableBlock(blockBefore)) {
      break;
    }
    end--;
  }
  return end === blocks.length ? blocks : blocks.slice(0, end);
}
